import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ManualVerificationStepperDetails {
  activeStep: number;
  backAction: boolean;
  selectedProviderId: string;
  selectedSessionId: string;
  selectedAppId: string;
}

const initialState: ManualVerificationStepperDetails = {
  activeStep: 1,
  backAction: false,
  selectedProviderId: '',
  selectedSessionId: '',
  selectedAppId: '',
};

const manualVerificationStepperDetailsSlice = createSlice({
  name: 'manualVerificationStepperDetails',
  initialState,
  reducers: {
    updateActiveStep(state, action: PayloadAction<number>) {
      state.activeStep = action.payload;
    },
    updateBackAction(state, action: PayloadAction<boolean>) {
      state.backAction = action.payload;
    },
    resetActiveStep(state) {
      state.activeStep = 0;
    },
    setSelectedProviderId(state, action: PayloadAction<string>) {
      state.selectedProviderId = action.payload;
    },
    setSelectedSessionId(state, action: PayloadAction<string>) {
      state.selectedSessionId = action.payload;
    },
    setSelectedAppId(state, action: PayloadAction<string>) {
      state.selectedAppId = action.payload;
    },
    resetManualVerificationStepperState() {
      return { ...initialState };
    },
  },
});

export const {
  updateActiveStep,
  updateBackAction,
  resetActiveStep,
  setSelectedProviderId,
  setSelectedSessionId,
  setSelectedAppId,
  resetManualVerificationStepperState,
} = manualVerificationStepperDetailsSlice.actions;

export default manualVerificationStepperDetailsSlice.reducer;
